import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=3e869f3b"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e869f3b')) {
      api.createRecord('3e869f3b', component.options)
    } else {
      api.reload('3e869f3b', component.options)
    }
    module.hot.accept("./Integration.vue?vue&type=template&id=3e869f3b", function () {
      api.rerender('3e869f3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/institution/Integration.vue"
export default component.exports